export * from './app.config-init';
export * from './app.config-default';
export * from './app.config-definition';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/config/index.ts